import React, { useState, useEffect } from "react";
import { AppShell, useMantineTheme, Loader } from "@mantine/core";
import Headr from "../../components/Headr";
import Footr from "../../components/Footr";
import { useSelector } from "react-redux";
import CreateNewModal from "../../components/CreateNewModal";
import DashboardStats from "./DashboardStats";
import DashboardExperiences from "./DashboardExperiences";
import getDashboardExperinces from "../../API/getDashboardExperinces";
function Dashboard() {
	const user = useSelector((state) => state.userInformationReducer.users);
	const [loading, setLoading] = useState(false);
	const [modeData, setmodelData] = useState();
	const [spaceID, setspaceID] = useState();
	const [opened, setOpened] = useState(false);
	const [dasboardExpereinces, setDasboardExpereinces] = useState();
	const theme = useMantineTheme();
	const refresh = async () => {
		const result = await getDashboardExperinces(user?.AccountId);
		setDasboardExpereinces(result);
	};
	useEffect(() => {
		const getUpdatedData = async () => {
			const result = await getDashboardExperinces(user?.AccountId);
			setDasboardExpereinces(result);
		};
		getUpdatedData();
	}, []);

	return (
		<AppShell
			styles={{
				main: {
					paddingTop: "10px",
					minHeight: "calc(100vh - 100px)",
					maxHeight: "auto",
					background:
						theme.colorScheme === "dark"
							? theme.colors.ivisit_dark[0]
							: theme.colors.gray[0],
				},
			}}
			footer={<Footr />}
			header={<Headr refresh={refresh} />}
		>
			<div style={{ paddingLeft: "1.5rem", paddingRight: "1.5rem" }}>
				<DashboardStats />
				<DashboardExperiences
					setLoading={setLoading}
					setmodelData={setmodelData}
					setspaceID={setspaceID}
					setOpened={setOpened}
					dasboardExpereinces={dasboardExpereinces}
					setDasboardExpereinces={setDasboardExpereinces}
				/>
				{opened && modeData && (
					<CreateNewModal
						data={modeData}
						opened={opened}
						setOpened={setOpened}
						spaceID={spaceID}
						isEdit={true}
						refresh={refresh}
					/>
				)}
			</div>
			{loading && (
				<div className="LoadingModal">
					<Loader className="LoadingModal_loader" />
				</div>
			)}
		</AppShell>
	);
}
export default Dashboard;
